import { defineStore } from "pinia";
import api from "@/util/api";

export const Store = defineStore("main", {
  state: () => {
    return {
      isMobile: false, // 移动端标识
      globalConfig: {}, // 全局配置
      friendlinkList: [], // 友情链接列表
    };
  },
  getters: {},
  actions: {
    setIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = !!flag;
    },
    // 存储全局配置
    async setConfig() {
      let res = await api.getConfig();
      this.globalConfig = res.data;
    },
    // 存储友情链接
    async setFriendlink() {
      let res = await api.getFriendlink();
      this.friendlinkList = res.data;
    },
  },
});
